import React, {Component} from 'react';
import { SocketContext } from '../context/socket';
import VoiceControl from './VoiceControl';

// import 'bootstrap/dist/css/bootstrap.min.css'; // imported in index.tsx
import '../styles/Chat.scss';

interface Message {
  message?: string;
  url?: string;
}

class DashboardChatWidget extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      messages: [],
      message: '',
    }

    this.socket = undefined!;
  }

  private socket: SocketIOClient.Socket;

  static contextType = SocketContext;
  context!: React.ContextType<typeof SocketContext>;

  private messagesEndRef: any = React.createRef();

  componentDidMount() {
    this.socket = this.context!;

    this.socket.on('chat', (msg: any) => {
      this.setState((state: any) => {
        return {
          messages: [...state.messages, {message: msg}],
        };
      });
      this.scrollToMessagesBottom();
    });
    this.socket.on('shipment', (msg: string) => {
      this.setState((state: any) => {
        return {
          messages: [...state.messages, {url: msg}],
        };
      });
      this.scrollToMessagesBottom();
    });
  }

  scrollToMessagesBottom() {
    this.messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }

  handleSubmit(e: any) {
    e.preventDefault();
    this.socket.emit('chat', this.state.message);
    this.setState({
      message: '',
    });
    return false;
  }


  handleChange(event: any) {
    this.setState({
      message: event.target.value,
    });
  }

  render() {
    //const { data } = this.props;
    return (
      <div id="chat-container" >
        <div id="messages">
          <ul>
            {this.state.messages.map((message: Message, i: number) => {
              if (message.url) {
                return <li key={i}>Your shipment has arrived: <a href={message.url}>Click here to download</a></li>
              } else if (message.message) {
                return <li key={i} dangerouslySetInnerHTML={{__html: message.message}}></li>
              }
              return null;
            }
            )}
          </ul>
          <div ref={this.messagesEndRef}></div>
        </div>
        <VoiceControl
          dashboardId={this.props.dashboardData.id}
          sessionId={this.props.session.id}
        />
        <div id="input-container">
          <form className="form-inline" onSubmit={(e: any) => this.handleSubmit(e)}>
            <input title="message" type="text" id="m" className="form-control" value={this.state.message} onChange={(event) => this.handleChange(event)}/>
            <button type="submit" className="btn btn-primary ml-2">Send</button>
          </form>
        </div>
      </div>
    );
  }
}

export default DashboardChatWidget;
